import BaseSelect, { SelectOption } from 'components/inputs/BaseSelect';
import { useEffect, useRef, useState } from 'react';
import { MenuPlacement } from 'react-select';
import { ActionMeta, OptionsType, ValueType } from 'react-select/src/types';

interface Props {
  id: string;
  className?: string;
  options: SelectOption[];
  value?: SelectOption | null;
  menuPlacement?: MenuPlacement;
  onChange: (newSelectedOption: SelectOption) => void;
  placeholder?: string;
  disabled?: boolean;
  label?: string;
  formatOptionLabel?: (data: any) => any;
}

interface SelectActionHandlers {
  [key: string]: Function;
}

const selectActionHandlers: SelectActionHandlers = {
  'select-option': (
    selectedOption: ValueType<SelectOption, false>
  ): SelectOption | null => {
    if (!selectedOption) {
      return null;
    }

    return selectedOption as SelectOption;
  },

  clear: () => {
    return null;
  },
};

const LanguageSelect = (props: Props) => {
  const selectedValue = props.value ? props.value.value : '';
  const ref = useRef<HTMLDivElement>(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [toggleClassName, setToggleClassName] = useState<string>('');

  const handleChange = (
    selectedOption:
      | SelectOption<string>
      | OptionsType<SelectOption<string>>
      | null,
    actionData: ActionMeta<SelectOption<string>>
  ): void => {
    if (selectActionHandlers[actionData.action]) {
      const updatedValue = selectActionHandlers[actionData.action](
        selectedOption,
        actionData
      );

      props.onChange(updatedValue);
    }
  };

  useEffect(() => {
    setToggleClassName(isMenuOpen ? 'open' : '');

    const checkIfClickedOutside = (e: any) => {
      if (isMenuOpen && ref.current && !ref.current.contains(e.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', checkIfClickedOutside);

    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [isMenuOpen]);

  return (
    <div ref={ref} onClick={() => setIsMenuOpen(!isMenuOpen)}>
      <BaseSelect
        {...props}
        className={`language-select-menu ${toggleClassName}`}
        options={props.options}
        onChange={handleChange}
        selected={selectedValue}
      />
    </div>
  );
};

export default LanguageSelect;
